<template>
  <a 
    class="category-item"
    :href="categoryLink"
    :style="itemStyle"
  >
    <div class="category-item__content d-flex flex-sm-column w-100 h-100">
        <div class="category-item__name" v-text="category.name"></div>
        <div class="category-item__icon" v-if="category.icon">
            <img :src="iconPath" />
        </div>
    </div>
  </a>
</template>

<script>
export default {
    name: "LatestCategoryItem",

    props: {
        category: {
            required: true,
            type: Object
        }
    },

    computed: {
    
        categoryLink(){
            return `/blog/${this.category.slug}`
        },

        iconPath() {
            return (`/storage/${this.category.icon.path}`).replace( 'original', 'avatar' )
        },

        itemStyle(){

            let color = this.category.bg_color

            let styles = {
                '--color': color
            }

            if( this.category?.main_image?.path ) styles['background-image'] = `url(/storage/${(this.category.main_image.path).replace( 'original', 'preview' )})`

            return styles

        }

    }

}
</script>
